// music_data.js

// modern western 12 tone scale

export const steps = ["-", "1/24", "1/8", "1/5", "1/4", "1/3", "13/32", "1/2", "3/5", "2/3", "4/5", "7/8", "1"];
export const ratios = ["1/1", "25/24", "9/8", "6/5", "5/4", "4/3", "45/32", "3/2", "8/5", "5/3", "9/5", "15/8", "2/1"];
export const intervals = [0.0, 0.0417, 0.0833, 0.0750, 0.0500, 0.0833, 0.0729, 0.0938, 0.1000, 0.0667, 0.1333, 0.0750, 0.1250];
export const factors = [1.0, 1.0417, 1.125, 1.2, 1.25, 1.3333, 1.4063, 1.5, 1.6, 1.6667, 1.8, 1.875, 2.0];
export const cycles = [1, 24, 8, 5, 4, 3, 32, 2, 5, 3, 5, 8, 2];
export const notes = ["A", "Bb", "B", "C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab"];

export const names = [
  "Unison",
  "Minor Second",
  "Major Second",
  "Minor Third",
  "Major Third",
  "Fourth",
  "Diminished Fifth",
  "Fifth",
  "Minor Sixth",
  "Major Sixth",
  "Minor Seventh",
  "Major Seventh",
  "Octave"
];

export const shortNames = [
  "Uni son",
  "Min 2nd",
  "Maj 2nd",
  "Min 3rd",
  "Maj 3rd",
  "Sub 4th",
  "Dim 5th",
  "Dom 5th",
  "Min 6th",
  "Maj 6th",
  "Min 7th",
  "Maj 7th",
  "Octive"
];

export const abbrevNames = [
  "Uni",
  "min2",
  "Maj2",
  "min3",
  "Maj3",
  "4th",
  "dim5",
  "5th",
  "min6",
  "Maj6",
  "min7",
  "Maj7",
  "Oct"
];

export const diatonicMajor = [
  "1. tonic ",
  "",
  "2 supertonic",
  "",
  "3 mediant",
  "4 subdominant",
  "",
  "5 dominant",
  "",
  "6 submediant",
  "",
  "7 leading tone",
  "tonic (octive)"
];

export const diatonicMinor = [
  "1. tonic ",
  "",
  "2 supertonic",
  "3 mediant",
  "",
  "4 subdominant",
  "",
  "5 dominant",
  "6 submediant",
  "",
  "7 subtonic",
  "",
  "tonic (octave)"
];

export const uni1 = 1;
export const min2 = 2;
export const maj2 = 3;
export const min3 = 4;
export const maj3 = 5;
export const sub4 = 6;
export const dim5 = 7;
export const dom5 = 8;
export const min6 = 9;
export const maj6 = 10;
export const min7 = 11;
export const maj7 = 12;

const flatten = {
  'A#': 'Bb',
  'C#': 'Db',
  'D#': 'Eb',
  'F#': 'Gb',
  'G#': 'Ab'
};

export function notesEqual(n1, n2) {
  if (n1.length != n2.length)
    return false;

  if (n1.length == 2) {
    if (n1[1] == '#')
      n1 = flatten[n1];
    if (n2[1] == '#')
      n2 = flatten[n2];
  }

  return n1 == n2;
}

export const altNotes = {
  'Ab': "G#",
  'A': "A",
  'A#': "Bb",
  'Bb': "A#",
  'B': "B",
  'C': "C",
  'C#': "Db",
  'Db': "C#",
  'D': "D",
  'D#': "Eb",
  'Eb': "D#",
  'E': "E",
  'F': "F",
  'F#': "Gb",
  'Gb': "F#",
  'G': "G",
  'G#': "Ab",
};

// Scales

export const chromaticScales = {
  'A': ["A", "A#", "B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A"],
  'A#': ["A#", "B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#"],
  'Bb': ["Bb", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb"],
  'B': ["B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"],
  'C': ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B", "C"],
  'C#': ["C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B", "C", "C#"],
  'Db': ["Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B", "C", "Db"],
  'D': ["D", "D#", "E", "F", "F#", "G", "G#", "A", "Bb", "B", "C", "C#", "D"],
  'D#': ["D#", "E", "F", "F#", "G", "G#", "A", "A#", "B", "C", "C#", "D", "D#"],
  'Eb': ["Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B", "C", "Db", "D", "Eb"],
  'E': ["E", "F", "F#", "G", "G#", "A", "A#", "B", "C", "C#", "D", "D#", "E"],
  'F': ["F", "F#", "G", "Ab", "A", "Bb", "B", "C", "Db", "D", "Eb", "E", "F"],
  'F#': ["F#", "G", "G#", "A", "A#", "B", "C", "C#", "D", "D#", "E", "F", "F#"],
  'Gb': ["Gb", "G", "Ab", "A", "Bb", "B", "C", "Db", "D", "Eb", "E", "F", "Gb"],
  'G': ["G", "G#", "A", "Bb", "B", "C", "C#", "D", "Eb", "E", "F", "F#", "G"],
  'G#': ["G#", "A", "A#", "B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#"],
  'Ab': ["Ab", "A", "Bb", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab"]
};

// Think of each of these arrays as overlays on a chromatic scale.
// For example:
//   The 3rd degree of the major scale is at position 4 of majorScale.
//   For the key of C the note at the 4 position of chromaticScales["C"] is "E".
// Note:
//   The numerical values represent the degree on the scale.

export const wholeToneScale = [1, , 2, , 3, , 4, , 5, , 6, , 1];

export const majorScale = [1, , 2, , 3, 4, , 5, , 6, , 7, 1];
export const minorScale = [1, , 2, 3, , 4, , 5, 6, , 7, , 1]
export const melodicMinorScale = [1, , 2, 3, , 4, , 5, , 6, , 7, 1];
export const harmonicMinorScale = [1, , 2, 3, , 4, , 5, 6, , , 7, 1];

export const pentatonicMajorScale = [1, , 2, , 3, , , 4, , 5, , , 1];
export const pentatonicMinorScale = [1, , , 2, , 3, , 4, , , 5, , 1];
export const bluesScale = [1, , , 2, , 3, 4, 5, , , 6, , 1];
export const penta6Scale = [1, , 2, , , 3, , 4, 5, 6, , , 1];

// diatonic scale degrees
export const tonic = 1
export const supertonic = 2
export const mediant = 3
export const subdominant = 4
export const dominant = 5
export const submediant = 6
export const leading_tone = 7

// Chords

export const romanDegrees = ["", "I", " ii", "iii", "IV", "V", "vi", "vii"]

// position of note in a chromatic scale
export const chord_index = {
  "tonic": 0,       // 1st
  "dominant": 7,    // 5th
  // triad
  "minor3": 3,      // minor 3rd
  "major3": 4,      // major 3rd
  "suspended4": 5,  // 4th
  // tetra
  "major6": 9,      // major 6th
  "minor7": 10,     // minor 7th
  "major7": 11,     // major 7th
  // added
  "minor9": 1,      // minor 2nd
  "added9": 2,      // major 2nd
}

export const majorChordSteps = [4, 3];
export const minorChordSteps = [3, 4];
export const diminishedChordSteps = [3, 3];
export const seventhChordSteps = [4, 3, 3];
export const major7thChordSteps = [4, 3, 4];
export const minor7thChordSteps = [3, 4, 3];

export const chordScales = [
  [1, , 2, , 3, 4, , 5, , 6, , 7],  // I
  [7, , 1, , 2, 3, , 4, , 5, , 6],  // ii
  [6, , 7, , 1, 2, , 3, , 4, , 5],  // iii
  [5, , 6, , 7, 1, , 2, , 3, , 4],  // IV
  [4, , 5, , 6, 7, , 1, , 2, , 3],  // V
  [3, , 4, , 5, 6, , 7, , 1, , 2],  // vi
  [2, , 3, , 4, 5, , 6, , 7, , 1]   // vii
];


// checks chord by looking at steps between notes
// so it is dependant upon ordering of notes, e.g. ["C","E","G"]
export function getChordNameX(chord) {
  if (chord.length < 1)
    return "0";
  var scale = chromaticScales[chord[0]];
  if (typeof scale == 'undefined')
    return "Z";
  var step1, step2, step3;

  // check major
  step1 = majorChordSteps[0];
  step2 = step1 + majorChordSteps[1];
  if (chord.length == 3 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]))
    return chord[0] + " Major";

  // check minor
  step1 = minorChordSteps[0];
  step2 = step1 + minorChordSteps[1];
  if (chord.length == 3 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]))
    return chord[0] + " minor";

  // check diminished
  step1 = diminishedChordSteps[0];
  step2 = step1 + diminishedChordSteps[1];
  if (chord.length == 3 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]))
    return chord[0] + " diminished";

  // check seventh
  step1 = seventhChordSteps[0];
  step2 = step1 + seventhChordSteps[1];
  step3 = step2 + seventhChordSteps[2];
  if (chord.length == 4 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]) && notesEqual(chord[3], scale[step3]))
    return chord[0] + " 7th";

  // check minor seventh
  step1 = minor7thChordSteps[0];
  step2 = step1 + minor7thChordSteps[1];
  step3 = step2 + minor7thChordSteps[2];
  if (chord.length == 4 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]) && notesEqual(chord[3], scale[step3]))
    return chord[0] + " minor 7th";

  // check major seventh
  step1 = major7thChordSteps[0];
  step2 = step1 + major7thChordSteps[1];
  step3 = step2 + major7thChordSteps[2];
  if (chord.length == 4 && notesEqual(chord[1], scale[step1]) && notesEqual(chord[2], scale[step2]) && notesEqual(chord[3], scale[step3]))
    return chord[0] + " Major 7th";

  return chord + " " + scale;
}

// checks chord by looking at position of notes on the key's chromatic scale

export function getChordName(notes, name = true) {
  if (notes.length < 1)
    return "invalid";

  var scale = chromaticScales[notes[0]];
  if (typeof scale === 'undefined')
    return "bad key";

  let fifth = "";
  let triad = "";
  let tetra = "";
  let added = "";

  for (const note of notes) {
    let pos = scale.indexOf(note);
    if (pos < 0)
      pos = scale.indexOf(altNotes[note]);
    if (pos < 0) {
      console.log(note + " " + altNotes[note]);
      return "bad notes"
    }

    switch (pos) {
      case chord_index.minor3:
        triad = name ? " minor" : " minor 3rd";
        break;
      case chord_index.major3:
        triad = name ? " " : " Major 3rd";
        break;
      case chord_index.suspended4:
        triad = name ? " sus4" : " suspended 4th";
        break;

      case chord_index.major6 - 1:
        tetra = name ? " min6" : " minor 6th";
        break;
      case chord_index.major6:
        tetra = name ? " 6" : " major 6th";
        break;
      case chord_index.minor7:
        tetra = name ? " 7" : " minor 7th";
        break;
      case chord_index.major7:
        tetra = name ? " Maj7" : " Major 7th";
        break;

      case chord_index.minor9:
        tetra = name ? " min9" : " minor 9th";
        break;
      case chord_index.added9:
        tetra = name ? " 9" : " major 9th";
        break;

      case chord_index.dominant:
        if (notes.length === 2)
          fifth = "";
        break;
      case chord_index.dominant - 1:
        fifth = name ? " dim5" : " diminished 5th";
        break;
      case chord_index.dominant + 1:
        fifth = name ? " aug5" : " augmented 5th";
        break;

    }

  }

  return notes[0] + fifth + (fifth || triad ? triad : " 5") + tetra + "";
}
